import styled from "styled-components"

import { CheckboxNew } from "components/form/CheckboxNew"

const TableRow = styled.div`
  display: flex;
  border-bottom: 1px solid var(--border-default);
  width: 100%;
`

const TableCell = styled.div<{ width?: string; align?: string }>`
  flex: ${({ width }) => (width ? `0 0 ${width}` : "1 0 0")};
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 44px;
  padding: 8px 20px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.48px;
  text-transform: uppercase;
  color: var(--text-secondary);
  text-align: ${({ align }) => align || "left"};
`

const EventCellContent = styled.div`
  display: flex;
  flex-direction: column;
`

const EventName = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.48px;
  text-transform: uppercase;
  color: var(--text-secondary);
`

const CheckboxCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 44px;
  padding: 6px 20px;
  width: 120px;
`

interface NotificationSettingRowProps {
  event_type_id: number
  event_name: string
  email_enabled: boolean
  inapp_enabled: boolean
  onEmailChange: (eventTypeId: number) => void
  onInAppChange: (eventTypeId: number) => void
  savingCheckbox: string | null
}

export const NotificationSettingRow = ({
  event_type_id,
  event_name,
  email_enabled,
  inapp_enabled,
  onEmailChange,
  onInAppChange,
  savingCheckbox,
}: NotificationSettingRowProps) => {
  const emailCheckboxId = `email-${event_type_id}`
  const inappCheckboxId = `inapp-${event_type_id}`

  return (
    <TableRow>
      <TableCell>
        <EventCellContent>
          <EventName>{event_name}</EventName>
        </EventCellContent>
      </TableCell>
      <CheckboxCell>
        <CheckboxNew
          id={emailCheckboxId}
          isChecked={email_enabled}
          onChange={() => onEmailChange(event_type_id)}
          disabled={savingCheckbox === emailCheckboxId}
        />
      </CheckboxCell>
      <CheckboxCell>
        <CheckboxNew
          id={inappCheckboxId}
          isChecked={inapp_enabled}
          onChange={() => onInAppChange(event_type_id)}
          disabled={savingCheckbox === inappCheckboxId}
        />
      </CheckboxCell>
    </TableRow>
  )
}
